import { render, staticRenderFns } from "./SubdomainCertList.vue?vue&type=template&id=418993aa&scoped=true&"
import script from "./SubdomainCertList.vue?vue&type=script&lang=js&"
export * from "./SubdomainCertList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418993aa",
  null
  
)

export default component.exports